import React, { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { formatDate, formatCurrency } from '../../utils/helpers';
import { TicketIcon, CalendarIcon, MapPinIcon } from '@heroicons/react/24/outline';
import axios from 'axios';

var userEmail;
var JSToken;
var accessToken;
if (localStorage.user) {
  userEmail = localStorage.user_email;
  JSToken = JSON.parse(localStorage.user);
  accessToken = JSToken.access_token;
}
const config = {
  headers: { Authorization: `Bearer ${accessToken}` },
};

export const EventHistoryCard = ({ delegateEmail }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `https://dash.bestdiplomats.org/api/method/get_event_history?delegate_email=${delegateEmail}`,
          config
        );
        if (response.status===200) {
          setEvents(response.data.data);
        } else {
          setError(response.error);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (delegateEmail) {
      fetchEvents();
    }
  }, [delegateEmail]);

  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6">
        <Skeleton height={30} width={250} className="mb-4" />
        <Skeleton count={3} height={100} className="mb-3" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="text-red-600">Error loading event history: {error}</div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <div className="bg-gradient-to-r from-emerald-500 to-teal-600 px-6 py-4">
        <h3 className="text-xl font-bold text-white">Event Attendance History</h3>
        <p className="text-emerald-100 text-sm">
          {events.length} {events.length === 1 ? 'event' : 'events'} attended
        </p>
      </div>

      <div className="p-6">
        {events.length === 0 ? (
          <div className="text-center py-12">
            <TicketIcon className="mx-auto h-12 w-12 text-gray-400" />
            <p className="mt-2 text-sm text-gray-500">No event history found</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Event</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Package</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Order Number</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Payment Mode</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Event Attendance</th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Checkin Type</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {events.map((event) => (
                  <tr key={event.name} className="hover:bg-gray-50">
                    <td className="px-4 py-4">
                      <div className="flex items-start gap-2">
                        <CalendarIcon className="h-5 w-5 text-gray-400 flex-shrink-0 mt-0.5" />
                        <div>
                          <p className="text-sm font-medium text-gray-900">{event.event_title}</p>
                          <p className="text-xs text-gray-500">{formatDate(event.event_start_date)}</p>
                          {event.event_location && (
                            <p className="text-xs text-gray-500 flex items-center gap-1 mt-1">
                              <MapPinIcon className="h-3 w-3" />
                              {event.event_location}
                            </p>
                          )}
                        </div>
                      </div>
                    </td>
                    <td className="px-4 py-4 text-sm text-gray-900">
                      {event.payment_package || 'N/A'}
                    </td>
                    <td className="px-4 py-4">
                      <span className="text-sm font-semibold text-gray-900">
                        {event.order_number || event.order_first_installment || "-"}
                      </span>
                    </td>
                    <td className="px-4 py-4 text-sm text-gray-600">
                      {event.payment_mode || 'N/A'}
                    </td>
                    <td className="px-4 py-4">
                      <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-semibold ${
                        event.invitation_status === 'Accepted' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'
                      }`}>
                        {event.invitation_status}
                      </span>
                    </td>
                    <td className="px-4 py-4 text-sm text-gray-600">
                      {event.attended ? 'True' : 'False'}
                    </td>
                    <td className="px-4 py-4 text-sm text-gray-600">
                      {event.checkin_type || 'N/A'}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};